import { LazyFeature, PageUnstyled, } from '@office-start/office-home-app-shared';
import React, { lazy } from 'react';
var SearchPageLazy = lazy(function () {
    return import(
    /* webpackChunkName: "search-page-component" */ '@office-start/search-page-component');
});
export var SearchPage = function (_a) {
    var searchRoot = _a.searchRoot;
    return (React.createElement(PageUnstyled, { name: "Search" },
        React.createElement(LazyFeature, null,
            React.createElement(SearchPageLazy, { searchRoot: searchRoot }))));
};
//# sourceMappingURL=SearchPage.js.map